import React from 'react';
import { createRoot } from 'react-dom/client';
import AdminApp from './App';
import './styles/admin.css';

const container = document.getElementById('admin-root');
if (!container) {
  throw new Error('Container element #admin-root not found');
}

const root = createRoot(container);
root.render(
  React.createElement(React.StrictMode, null,
    React.createElement(AdminApp)
  )
);
